import Image from 'shared/components/base/image/Image'

type PropType = {
  name: string
  role: string
  status: string
  imageUrl: string
}
const TransferredOperator = (props: PropType) => {
  return (
    <div className="flex flex-col">
      <div className="flex">
        <Image
          className="rounded-full w-11 h-11"
          src={props.imageUrl}
          height={44}
          width={44}
          alt={props.name}
        />

        <div className="flex flex-col mr-2">
          <p className="text-[#858C94] font-medium text-3.25 leading-5.5 mt-2">
            {props.name}
          </p>
          <p className="text-[#A3AED0] font-normal text-2.75 leading-6 -mt-2">
            {props.role}
          </p>
        </div>
      </div>
      <p className="text-[#107715] font-normal text-2.75 leading-6">
        {props.status}
      </p>
      <div className="mt-1 h-24 bg-[#E2E2E2] w-0.5" />
    </div>
  )
}

export default TransferredOperator
